module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Watch#1-a439c4ad2de2e142f1fe800baec2842b.svg";